import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import Button from '@atlaskit/button';
import { IconButton } from '@atlaskit/button/new';

const i18n = defineMessages({
	aiMenuAriaText: {
		id: 'ai-content-actions.popup-trigger.aria-text',
		defaultMessage: 'AI Actions Menu',
		description: 'Aria label for the AI actions menu which has no visible text',
	},
});

type AIContentActionsMenuPopupPlaceholderProps = {
	shouldRenderWhite?: boolean;
};

export const AIContentActionsMenuPopupPlaceholder = ({
	shouldRenderWhite = false,
}: AIContentActionsMenuPopupPlaceholderProps) => {
	const intl = useIntl();

	if (shouldRenderWhite) {
		return (
			<Button
				testId="ai-content-actions-menu-button-placeholder"
				appearance="subtle"
				isSelected={false}
				isDisabled
				iconAfter={
					<ChevronDownIcon
						label={intl.formatMessage(i18n.aiMenuAriaText)}
						spacing="spacious"
						size="small"
					/>
				}
			/>
		);
	}

	return (
		<IconButton
			testId="ai-content-actions-menu-button-placeholder"
			appearance="subtle"
			isSelected={false}
			isDisabled
			icon={(iconProps) => <ChevronDownIcon {...iconProps} spacing="spacious" size="small" />}
			label={intl.formatMessage(i18n.aiMenuAriaText)}
		/>
	);
};
